import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { labFieldKeys } from '../constants';
import { useApiToast } from '@hooks/useApiToast';

export const useDeleteLabFieldValue = () => {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useApiToast();

  return useMutation<void, Error, string>({
    mutationFn: async (value: string) => {
      await bffApiClient.delete(
        `/api/lab-field/values/${encodeURIComponent(value)}`
      );
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: labFieldKeys.all });
      showSuccess('labField.deleteSuccess', 'settings');
    },

    onError: error => {
      showError('labField.deleteError', error, 'settings');
    }
  });
};
